import StateModel from "User/store/models/stateModel";

const getters = {
	/** @param {StateModel} state */
	userName: state => {
		let name = state.userName === null || state.userName === undefined ? "" : state.userName;
		return name;
	},
	/** @param {StateModel} state */
	userLogged: state => {
		let isLogged = state.userLogged === null || state.userLogged === undefined ? false : state.userLogged;
		return isLogged;
	}
};
export { getters };